import React from 'react';

import { IconProps } from '../../DefaultIcon';

export function CareerManagementIcon({ className }: IconProps) {
  return (
    <svg
      width="70"
      height="95"
      viewBox="0 0 70 95"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_4_4649)">
        <path
          d="M61.9394 95V26.9886C61.9394 25.2614 60.4546 23.75 58.7576 23.75H3.18182C1.48485 23.75 0 25.0455 0 26.9886V86.3636C0 91.1136 3.81818 95 8.48485 95H61.9394Z"
          fill="#EAEEF9"
        />
        <path
          d="M46.2424 88.9545H27.3636C26.9394 88.9545 26.303 88.5227 26.303 87.875C26.303 87.2273 26.7273 87.0114 27.3636 87.0114H46.2424C46.6667 87.0114 47.303 87.4432 47.303 87.875C47.303 88.3068 46.6667 88.9545 46.2424 88.9545Z"
          fill="#B0B9CF"
        />
        <path
          d="M22.4848 88.9545H20.3636C19.9394 88.9545 19.303 88.5227 19.303 87.875C19.303 87.2273 19.7273 87.0114 20.3636 87.0114H22.4848C22.9091 87.0114 23.3333 87.4432 23.3333 87.875C23.3333 88.3068 23.1212 88.9545 22.4848 88.9545Z"
          fill="#B0B9CF"
        />
        <path
          d="M8.69697 95C12.7273 95 16.1212 91.9772 16.7576 87.875C16.7576 87.2272 17.3939 86.7954 18.0303 86.7954H68.7273C69.5758 86.7954 70.2121 87.4431 70 88.3068C69.3636 92.1931 65.9697 95 61.9394 95H8.69697Z"
          fill="#00C4B3"
        />
        <path
          d="M31.6061 56.1364C23.7576 56.1364 17.1818 62.1818 16.1212 69.9545C15.9091 71.0341 16.7576 72.1136 17.8182 72.1136H45.1818C46.2424 72.1136 47.0909 71.0341 46.8788 69.9545C46.0303 61.9659 39.4545 56.1364 31.6061 56.1364Z"
          fill="#00416B"
        />
        <path
          d="M43.4848 47.5001C43.4848 54.1932 38.1818 59.8069 31.3939 59.8069C24.8182 59.8069 19.303 54.4091 19.303 47.5001C19.303 40.8069 24.6061 35.1932 31.3939 35.1932C38.1818 35.1932 43.4848 40.8069 43.4848 47.5001Z"
          fill="#EAEEF9"
        />
        <path
          d="M39.8788 47.5C39.8788 52.25 36.0606 56.1364 31.3939 56.1364C26.7273 56.1364 22.9091 52.25 22.9091 47.5C22.9091 42.75 26.7273 38.8636 31.3939 38.8636C36.2727 38.8636 39.8788 42.75 39.8788 47.5Z"
          fill="#00416B"
        />
        <path
          d="M24.8182 23.3182C24.6061 23.3182 24.6061 23.3182 24.3939 23.3182C23.9697 23.1023 23.7576 22.6705 23.9697 22.2387L29.2727 11.875C29.4848 11.4432 29.9091 11.2273 30.3333 11.4432C30.7576 11.6591 30.9697 12.091 30.7576 12.5228L25.4545 22.8864C25.4545 23.1023 25.2424 23.3182 24.8182 23.3182Z"
          fill="#EAEEF9"
        />
        <path
          d="M57.4848 23.3182H57.2727L29.9091 12.7386C29.4848 12.5227 29.2727 12.0909 29.4848 11.6591C29.697 11.2273 30.1212 11.0114 30.5454 11.2273L57.697 21.5909C58.1212 21.8068 58.3333 22.2386 58.1212 22.6705C57.9091 23.1023 57.697 23.3182 57.4848 23.3182Z"
          fill="#EAEEF9"
        />
        <path
          d="M30.1212 15.7614C29.0606 15.7614 28 15.3296 27.1515 14.6819C26.303 13.8182 25.6667 12.5228 25.6667 11.2273C25.6667 10.7955 26.0909 10.3637 26.5152 10.3637C26.9394 10.3637 27.3636 10.7955 27.3636 11.2273C27.3636 12.091 27.7879 12.9546 28.4242 13.3864C29.0606 14.0341 29.9091 14.25 30.7576 14.0341C31.8182 14.0341 32.8788 12.9546 32.8788 11.4432C33.0909 9.93186 32.2424 8.85232 30.9697 8.4205C29.9091 7.98868 29.2727 7.12504 29.2727 6.0455V4.31823C29.2727 3.88641 29.697 3.45459 30.1212 3.45459C30.5455 3.45459 30.9697 3.88641 30.9697 4.31823V6.26141C30.9697 6.69323 31.1818 6.90914 31.6061 7.12504C33.5152 7.77277 34.7879 9.71595 34.5758 11.875C34.3636 14.0341 32.6667 15.5455 30.7576 15.7614C30.5455 15.7614 30.3333 15.7614 30.1212 15.7614Z"
          fill="#00C4B3"
        />
        <path
          d="M2.75757 23.3182C2.54545 23.3182 2.12121 23.1023 2.12121 22.8864C1.90909 22.4546 2.12121 22.0228 2.54545 21.8069L29.9091 11.4432C30.3333 11.2273 30.7576 11.4432 30.9697 11.875C31.1818 12.3069 30.9697 12.7387 30.5455 12.9546L3.18182 23.1023C2.9697 23.1023 2.9697 23.3182 2.75757 23.3182Z"
          fill="#EAEEF9"
        />
        <path
          d="M35.4242 23.3182C35.2121 23.3182 34.7879 23.1023 34.7879 22.8864L29.4848 12.5228C29.2727 12.091 29.4848 11.6591 29.9091 11.4432C30.3333 11.2273 30.7576 11.4432 30.9697 11.875L36.2727 22.2387C36.4848 22.6705 36.2727 23.1023 35.8485 23.3182C35.6364 23.1023 35.4242 23.3182 35.4242 23.3182Z"
          fill="#EAEEF9"
        />
        <path
          d="M32.0303 5.39773H28.4242C27.5758 4.53409 27.1515 4.10227 26.303 3.23864V1.07955L27.1515 0H32.8788C33.303 0.431818 33.5152 0.647727 33.9394 1.07955V3.23864C33.303 4.10227 32.6667 4.53409 32.0303 5.39773Z"
          fill="#00416B"
        />
        <path
          d="M3.81817 23.5341H1.69696C1.48484 23.5341 1.27272 23.3182 1.27272 23.1023V22.0227C1.27272 21.1591 1.90908 20.5114 2.75757 20.5114C3.60605 20.5114 4.24242 21.1591 4.24242 22.0227V23.1023C4.45454 23.3182 4.24242 23.5341 3.81817 23.5341Z"
          fill="#00416B"
        />
        <path
          d="M24.8182 23.5341H22.2727C22.0606 23.5341 21.8485 23.3182 21.8485 23.1023V22.0227C21.8485 21.1591 22.4849 20.5114 23.3333 20.5114H24.8182V23.5341Z"
          fill="#00416B"
        />
        <path
          d="M27.5758 23.534H25.0303V20.2954H26.5152C27.3636 20.2954 28 20.9431 28 21.8068V22.8863C28 23.3181 27.7879 23.534 27.5758 23.534Z"
          fill="#00416B"
        />
        <path
          d="M35.4242 23.5341H32.8788C32.6667 23.5341 32.4545 23.3182 32.4545 23.1023V22.0227C32.4545 21.1591 33.0909 20.5114 33.9394 20.5114H35.4242V23.5341Z"
          fill="#00416B"
        />
        <path
          d="M37.9697 23.534H35.4242V20.2954H36.9091C37.7576 20.2954 38.3939 20.9431 38.3939 21.8068V22.8863C38.3939 23.3181 38.1818 23.534 37.9697 23.534Z"
          fill="#00416B"
        />
        <path
          d="M58.3333 23.5341H56.2121C56 23.5341 55.7879 23.3182 55.7879 23.1023V22.0227C55.7879 21.1591 56.4242 20.5114 57.2727 20.5114C58.1212 20.5114 58.7576 21.1591 58.7576 22.0227V23.1023C58.9697 23.3182 58.7576 23.5341 58.3333 23.5341Z"
          fill="#00416B"
        />
        <path
          d="M31.3939 2.59086C31.3939 3.23859 30.7576 3.88632 30.1212 3.88632C29.4848 3.88632 28.8485 3.23859 28.8485 2.59086C28.8485 1.94314 29.4848 1.29541 30.1212 1.29541C30.7576 1.29541 31.3939 1.94314 31.3939 2.59086Z"
          fill="#FBFCFE"
        />
      </g>
      <defs>
        <clipPath id="clip0_4_4649">
          <rect width="70" height="95" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
